import React from "react";
import "./RemoveProWarning.scss";
import { useHistory } from "react-router";
import Modal from "react-bootstrap/Modal";
function Profeature(props) {
  const history = useHistory();
  const removeProfeatures = () => {
    props.removeProfeatures();
    props.onHide();
  };

  return (
    <>
      <Modal
        {...props}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="profeature-modal"
      >
        <Modal.Body>
          <img
            onClick={props.onHide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="">
            <div className="d-flex justify-content-between">
              <div className="profeature-left-image">
                {/* <img
                  src="/images/profeature.png"
                  alt="profeature"
                  className="popupimage"
                /> */}
              </div>

              <div className="px-3">
                <div className="">
                  <>
                    <h4 className="header-feature mb-3">Revert Changes. </h4>
                    <p className="sub-text-feature mb-4">
                      Are you sure you want to revert the changes you made to
                      your resume? You can always undo the revert and continue.
                    </p>
                  </>
                </div>
                <div className="d-flex mt-3">
                  <button
                    className="btn primarybtn bgsuccess text-white p-2  mr-5"
                    onClick={removeProfeatures}
                  >
                    Yes, Revert
                  </button>
                  <button
                    className="btn outline-secondary  p-2 "
                    onClick={props.onHide}
                  >
                    Keep Edits
                  </button>
                </div>
                {/* <div className="col-md-12">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-100"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div> */}
              </div>
            </div>

            {/* {props && props.hideEditing ? (
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-100"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <button
                    className="btn primarybtn float-right w-75 mainborder"
                    onClick={props.onHide}
                  >
                    Continue Editing
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-75"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Profeature;
